
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import getOptionsAdminEmail from "../store/refunds/getOptionsAdminEmail/actions";

const useOptionsAdminEmail = (opt_id) => {
    const dispatch = useDispatch();
    const { loading, data, error } = useSelector((store) => store.getOptionsAdminEmail);
    useEffect(() => {
            dispatch(getOptionsAdminEmail(opt_id));
        
    }, [dispatch]);

    return [loading, data, error];
};
export default useOptionsAdminEmail;
